import { UserOutlined } from '@ant-design/icons'
import { Avatar, Space, TableColumnsType, Typography } from 'antd'
import React, { useMemo } from 'react'

import { NormalStatus } from '@/constants/normal-status'
import { Creator } from '@/model/creator'
import { Employee } from '@/model/employee'
import { Role } from '@/model/role'

import EmployeeOperations from '../components/employee-operations'

export interface Record extends Employee {
  assignedCreators: Creator[];
  roles: Role[];
  groupIds: number[];
}

export default function useEmployeeColumns(
  openUpdateFormModal: (employee: Employee) => void,
): TableColumnsType<Record> {
  return useMemo(
    () => [
      {
        title: 'Employee',
        dataIndex: 'name',
        render: (name, { avatarUrl }) => (
          <Space>
            <Avatar icon={<UserOutlined />} shape="circle" src={avatarUrl} />
            {name}
          </Space>
        ),
      }, {
        title: 'Role',
        dataIndex: 'roles',
        render: (roles: Record['roles']) => {
          return roles.map((role) => role.name).join(', ')
        },
      }, {
        title: 'Status',
        dataIndex: 'status',
        render: (status: Record['status']) => (
          <Typography.Text
            type={status === NormalStatus.Activated ? 'success' : 'danger'}
          >
            {status}
          </Typography.Text>
        ),
      }, {
        title: 'Operations',
        key: 'operations',
        render: (_, employee) => {
          return <EmployeeOperations employee={employee} openUpdateFormModal={openUpdateFormModal} />
        },
      },
    ],
    [openUpdateFormModal],
  )
}
